import React, { useState,useEffect } from 'react';
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';


const InfoScreen = ({ type,message,title,onClose }) => {
    const {t} = useTranslation();



    const alertType = {
        error: 'redAllert',
        success: 'greenAllert',
        warning: 'yellowAllert',
      }[type] || '';






    return (
        <>
        
        <div className="modal fade show AlertMsg registration_modal" id="AlertMsg" tabindex="-1" aria-labelledby="myModalLabel"  aria-hidden="true"
        
        style={{ display: 'block' }}
        >
      <div className="modal-dialog modal-dialog-scrollable">
            <div className="modal-content">
               <div className={`modal-body ${alertType}`} >
                  <div className="body main-layout-item promotion_box ColumnSection_list_one">
                     <div className="Home_root">
                        <div className="Home_games">
                           <div className="Home_header">
                              <a href="#" className="HomeSection_header" data-bs-dismiss="modal" aria-label="Close">
                                 <div class="HomeSection_icon">
                                    <button className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                 </div>
                                 <div className="HomeSection_label"  onClick={onClose}>{t('Close')}</div>
                                 <div className="HomeSection_right">
                                 </div>
                              </a>
                           </div>
                           <div className="HomeSectionCasinoGames_list">
                              
                              <h3>{title}</h3>
                                <p>{message}</p>
                               

                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
       </div>
        
        </>
    );
    

}





const InfoScreenManager = {
  container: null,
  show({ type, message, title,isTimer = false }) {
    if (!this.container) {
      this.container = document.createElement('div');
      document.body.appendChild(this.container);
    }


    if(isTimer == true){
        setTimeout(() => {
            this.hide();
        }, 3000);
    }

    const handleClose = () => {
      this.hide();
    };

    ReactDOM.render(
      <InfoScreen
        type={type}
        message={message}
        title={title}
        onClose={handleClose}
      />,
      this.container
    );
  },
  hide() {
    if (this.container) {
      ReactDOM.unmountComponentAtNode(this.container);
      document.body.removeChild(this.container);
      this.container = null;
    }
  },
};

export default InfoScreenManager;